import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "departments-list mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "list-loading"
}
const _hoisted_4 = { class: "list list-scrollbar" }
const _hoisted_5 = { class: "column-space" }
const _hoisted_6 = { class: "column-space" }
const _hoisted_7 = { class: "column-space" }
const _hoisted_8 = { class: "column-space" }
const _hoisted_9 = { class: "column-space" }
const _hoisted_10 = { class: "column-space" }
const _hoisted_11 = { class: "column-space" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { colspan: "9" }

import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import ResizableList from '@/components/ResizableList.vue';
import { formatDate } from "@/services/functions"
import SelfAccount from "@/types/SelfAccount"
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import { computed } from "vue"
import i18n from "@/lang/i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentsList',
  props: {
    departments: {},
    isLoading: { type: Boolean },
    isSearchCompleted: { type: Boolean },
    deleteAuthority: { type: Boolean },
    selfAccount: {},
    isManagementOffice: { type: Boolean },
    isDepartment: { type: Boolean },
    openModal: { type: Function },
    deleteModal: { type: Function }
  },
  setup(__props: any) {

const props = __props

const HEADER = ([
  i18n.global.t('pages.departments.list.header.operationOffice'),
  i18n.global.t('pages.departments.list.header.firstLevel'),
  i18n.global.t('pages.departments.list.header.secondLevel'),
  i18n.global.t('pages.departments.list.header.updatedAt'),
  i18n.global.t('pages.departments.list.header.updatedBy'),
  i18n.global.t('pages.departments.list.header.form'),
  i18n.global.t('pages.departments.list.header.delete'),
])

const datetimeFormat = computed(() => (datetime: string) => {
  const d = new Date(datetime)
  return formatDate(d)
})

const headerClass = computed(() => (index: number) => {
  if (index == 5 || index == 6) return 'd-flex ml-4'
  return 'd-flex'
})

const isDelete = computed(() => (departmentId: number) => {
  if (!props.isDepartment) return true
  return departmentId != props.selfAccount.login_organization_id
})

const firstLevelDepartmentName = computed(() => (department: getDepartmentAllParams) => {
  if (!department.parent_department) return department.name
  return department.parent_department.name
})

const secondLevelDepartmentName = computed(() => (department: getDepartmentAllParams) => {
  if (!department.parent_department) return ''
  return department.name
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : (!props.isSearchCompleted && props.isManagementOffice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".list" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADER, (item, index) => {
                    return _createElementVNode("th", {
                      key: index,
                      class: "table-header column-space"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(headerClass.value(index))
                      }, _toDisplayString(item), 3)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (__props.departments?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.departments, (department) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: department.id
                      }, [
                        _createElementVNode("td", _hoisted_5, _toDisplayString(department.operation_office.operation_office_name), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(firstLevelDepartmentName.value(department)), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(secondLevelDepartmentName.value(department)), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(datetimeFormat.value(department.updated_at)), 1),
                        _createElementVNode("td", _hoisted_9, [
                          _createVNode(DisplayFullnameFromUpdatedBy, {
                            updatedBy: department.updated_by
                          }, null, 8, ["updatedBy"])
                        ]),
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            class: "d-flex px-0",
                            onClick: ($event: any) => (props.openModal(department))
                          }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("span", { class: "material-symbols-outlined" }, " edit_note ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          (props.deleteAuthority && isDelete.value(department.id))
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                variant: "text",
                                class: "d-flex px-0",
                                onClick: ($event: any) => (props.deleteModal(department))
                              }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined delete-icon" }, " delete ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  : (!__props.departments?.length && !props.isLoading && props.isSearchCompleted)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})